import { useFetch } from '@/composables/useFetch';
import { ProjectDataService } from '@/services';
import { IDigitalizationProjectDetailsDto } from 'types';
import { useI18n } from 'vue-i18n';

export function useGetDigitalizationProjectData(projectId: string) {
  const { t } = useI18n();

  const { isLoading: isLoadingProject, data: project } =
    useFetch<IDigitalizationProjectDetailsDto>(
      async () =>
        await ProjectDataService.getDigitalizationProjectData(projectId),
      () => {
        t('commonProjects.errors.errorLoadingProjectData');
      },
    );

  return { isLoadingProject, project };
}
